import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'color-picker.edit.label',
		defaultMessage: 'Change color',
		description: 'Field label. Appears when a user hovers the field.',
	},
});
export default messages;
